var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"mt-5 has-text-centered has-text-weight-bold is-size-3 title has-text-black"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }